/** Formik field names that currently have validation errors. */
export function invalidFieldKeysFromFormikErrors(
  errors: Record<string, unknown> | undefined
): string[] {
  if (!errors || typeof errors !== "object") return [];

  const keys: string[] = [];
  for (const [key, value] of Object.entries(errors)) {
    if (value === undefined || value === null) continue;
    if (typeof value === "string") {
      if (value.length > 0) keys.push(key);
      continue;
    }
    if (Array.isArray(value)) {
      const hasMeaningful = value.some((entry) => {
        if (entry == null) return false;
        if (typeof entry === "string") return entry.length > 0;
        if (typeof entry === "object") return Object.keys(entry as object).length > 0;
        return true;
      });
      if (hasMeaningful) keys.push(key);
      continue;
    }
    if (typeof value === "object" && Object.keys(value as object).length > 0) {
      keys.push(key);
    }
  }
  return keys;
}

export function hasFormikFieldError(
  errors: Record<string, unknown> | undefined,
  field: string
): boolean {
  return invalidFieldKeysFromFormikErrors(errors).includes(field);
}
